import React from 'react';
import W2Documents from '../components/W2Documents';

const W2Page = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">W2 Documents</h1>
      <W2Documents />
    </div>
  );
};

export default W2Page; 